import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-main',
  template: `<router-outlet></router-outlet>`,
})
export class LayoutMainComponent {}
